import AboutPblDefault from '../components/about/subpages/AboutPblDefault.js';
import AboutPblExamples from '../components/about/subpages/AboutPblExamples.js';

export default [
    {
        id: 1,
        name: 'what-is',
        component: AboutPblDefault
    },
    {
        id: 2,
        name: 'how-search',
        component: AboutPblDefault
    },
    {
        id: 3,
        name: 'what-in',
        component: AboutPblDefault,
        children: [
            {
                id: 31,
                name: 'examples',
                component: AboutPblExamples
            }
        ]
    },
    {
        id: 4,
        name: 'how-create',
        component: AboutPblDefault
    },
    {
        id: 5,
        name: 'source',
        component: AboutPblDefault
    },
    {
        id: 6,
        name: 'conditions',
        component: AboutPblDefault,
        children: [
            {
                id: 61,
                name: 'api-docs',
                component: AboutPblDefault
            }
        ]
    },
    {
        id: 7,
        name: 'team',
        component: AboutPblDefault
    },
    {
        id: 8,
        name: 'contact',
        component: AboutPblDefault
    },
    {
        id: 9,
        name: 'privacy-policy',
        component: AboutPblDefault
    },
    {
        id: 10,
        name: 'accessibility',
        component: AboutPblDefault
    },
];



// WEBPACK FOOTER //
// ./src/scripts/AboutSubpages.js